import { Tooltip } from "antd";
import React from "react";
import { BsExclamationCircle } from "react-icons/bs";
import { componentPalette } from "src/theme/component-palette";
interface WarningProps {
  title?: string;
}
const Warning: React.FC<WarningProps> = ({ title }) => {
  return (
    <Tooltip title={title}>
      <div style={{ padding: 2, marginRight: 2 }}>
        <BsExclamationCircle color={componentPalette.red} size={18} />
      </div>
    </Tooltip>
  );
};

export default Warning;
